import TimelineIcon from '@mui/icons-material/Timeline';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';
import { useCallback, useEffect } from 'react';
import { geojson, linestring } from '../map.constants';
import { MAP_SOURCE_IDS } from '../Utils/constants';
import { rulerEvent } from '../Utils/utils';
import { useRulerButtonStyles } from './RulerButton.style';

export const RulerButton = ({
  map,
  rulerActive = false,
  setRulerActive,
  mapLoaded,
  distanceUnits,
}) => {
  const classes = useRulerButtonStyles();

  // prepend the ruler control to the mapbox controls if ruler is enabled
  const setRuler = useCallback(
    node => {
      if (mapLoaded && node) {
        // mapbox control group (bottom-right nav controls) container
        const groupContainer = document.querySelectorAll(
          '.mapboxgl-ctrl-bottom-right .mapboxgl-ctrl-group',
        )[0];
        groupContainer.prepend(node);
      }
    },
    [mapLoaded],
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: Requires refactor
  useEffect(() => {
    if (map) {
      map.toggleMapRuler(rulerActive);
    }
  }, [rulerActive]);

  const onRulerClick = () => {
    map.onClickRulerCallback = rulerEvent(map, geojson, linestring, distanceUnits);
    setRulerActive(true);
  };

  const onRulerClose = () => {
    geojson.features = [];
    linestring.geometry.coordinates = [];
    const rulerSource = map.getSource(MAP_SOURCE_IDS.geojson);
    if (rulerSource) {
      rulerSource.setData(geojson);
    }
    setRulerActive(false);
  };

  const onRulerButtonClick = () => (rulerActive ? onRulerClose() : onRulerClick());

  return (
    <div ref={setRuler}>
      <Tooltip title='Ruler' aria-label='ruler tooltip'>
        <IconButton
          id='ruler-button'
          onClick={onRulerButtonClick}
          edge='start'
          className={clsx(classes.rulerAction, {
            [classes.rulerActionSelected]: rulerActive,
          })}
          size='large'
        >
          <TimelineIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};
